<div *ngIf="isConfigLoading" class="rewards-tab-loading">
  <div class="loading-spinner"></div>
  <p class="loading-text">Loading rewards...</p>
</div>

<app-rewards-tab-v2 *ngIf="!isConfigLoading && rewardsV2Enabled"></app-rewards-tab-v2>
<app-rewards-tab-v1 *ngIf="!isConfigLoading && !rewardsV2Enabled"></app-rewards-tab-v1>
